import { PageRef } from 'providers/page-ref';

export type CoachBrandingPageParams = {};

/**
 * Coach Branding setup page (Tier 1 white-labeling, #3707). Reached from the
 * Coaching screen header palette icon. Lets a coach set their logo, brand name,
 * and one accent color; on save it persists the as-coach branding and fans it
 * out to already-claimed clients. See design-docs/coach-white-labeling.md.
 */
export const ICoachBrandingPage: PageRef<CoachBrandingPageParams, void> = {
  pageName: 'CoachBrandingPage',
} as PageRef<CoachBrandingPageParams, void>;
